export const resetDataList = (res) => {
    // 格式化 key、value
    const newRes = res.map((item) => {
        return {
            key: item.id,
            value: item.title || item.name
        }
    })
    return newRes
}

export const formatObjectToArray = (data, key) => {
    // 对象转数组
    if (data[key] && Object.keys(data[key]).length > 0) {
        data[key] = Object.entries(data[key]).map((item) => {
            return {
                name: item[0],
                value: item[1]
            }
        })
    }
    return data
}

export const formatFileUrlToObject = (item, key = 'file_ids_urls', size = '') => {
    // 格式化 后台的{id:url} 为[{id：id, url:url}]
    const ids_urls = []
    const obj = item[key]
    const isArray = obj instanceof Array // 解决：后端返回的数据有时候{}有时候[]

    if (!isArray && item[key] && Object.keys(obj).length > 0) {
        Object.keys(obj).map((i_item) => {
            ids_urls.push({
                id: i_item,
                url: `${obj[i_item]}${size}`
            })
        })
        item[key] = ids_urls
    }
    return item
}

export const getTreeChildren = (data, id) => {
    // 树结构根据id找到节点
    var hasFound = false // 表示是否有找到id值
    var result = null
    const getChild = (data, id) => {
        if (Array.isArray(data) && !hasFound) {
            // 判断是否是数组并且没有找到的情况下，
            data.forEach((item) => {
                if (item.id === id) {
                    result = item
                    hasFound = true // 表示找到id值
                } else if (item.child) {
                    getChild(item.child, id) // 递归调用下边的子项
                }
            })
        }
    }
    getChild(data, id)
    return result
}
